import { render, staticRenderFns } from "./finishedServicesBB.vue?vue&type=template&id=963309ee&scoped=true&"
import script from "./finishedServicesBB.vue?vue&type=script&lang=js&"
export * from "./finishedServicesBB.vue?vue&type=script&lang=js&"
import style0 from "./finishedServicesBB.vue?vue&type=style&index=0&id=963309ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "963309ee",
  null
  
)

export default component.exports